import React, { useState } from 'react';
import { string, arrayOf, shape } from 'prop-types';
import css from './SectionFAQ.module.css';

const SectionFAQ = props => {
  const { title, subtitle, faqs } = props;
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = index => setOpenIndex(openIndex === index ? null : index);

  return (
    <section className={css.root}>
      <div className={css.container}>
        <h2 className={css.title}>{title}</h2>
        {subtitle && <p className={css.subtitle}>{subtitle}</p>}

        <div className={css.faqContainer}>
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={index} className={css.item}>
                <button
                  className={css.question}
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                  id={`faq-question-${index}`}
                >
                  {faq.icon && <span className={css.icon} aria-hidden="true">{faq.icon}</span>}
                  <span className={css.questionText}>{faq.question}</span>
                  <span className={css.chevron} aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      {isOpen
                        ? <polyline points="18 15 12 9 6 15" />
                        : <polyline points="6 9 12 15 18 9" />}
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <p
                    className={css.answer}
                    id={`faq-answer-${index}`}
                    role="region"
                    aria-labelledby={`faq-question-${index}`}
                  >
                    {faq.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

SectionFAQ.defaultProps = {
  subtitle: null,
  faqs: [],
};

SectionFAQ.propTypes = {
  title: string.isRequired,
  subtitle: string,
  faqs: arrayOf(
    shape({
      icon: string,
      question: string.isRequired,
      answer: string.isRequired,
    })
  ),
};

export default SectionFAQ;
